import * as preact from "preact";
import { $$ } from "../../Core/Common";
import { DataPanel, IDataPanelProps } from "../DataPanel/DataPanel";
import { TextBox } from "../TextBox/TextBox";
import { $$videoPlayer } from "../VideoPlayer/VideoPlayer";

import Video = EventLibrary.Model.Video;

interface IVideoSelectorProps extends IDataPanelProps<Video[]>
{

}

enum VideoType
{
    Youtube = 1,
    Vimeo = 2
}

export interface IVideoSelectorState
{
    data: Video[];
}

export interface IVideoControls
{
    DescriptionBox?: TextBox;
    UrlBox?: TextBox;
    ImagePreview?: HTMLImageElement;
}

export class VideoSelector extends DataPanel<Video[], IVideoSelectorProps>
{
    private _videoControls: IVideoControls[];
    private _pnlVideos: HTMLElement;

    constructor(props: IVideoSelectorProps)
    {
        super(props);
        this._videoControls = [];
    }

    public override setData(data?: Video[])
    {
        this._videoControls = [];
        let videos = data || [];

        this._pnlVideos.innerHTML = "";
        videos.forEach((video) => 
        {
            this._addVideo(video);
        })
    }

    public override getData(): Video[]
    {
        let videos: Video[] = [];
        for (let vidControl of this._videoControls)
        {
            let url = vidControl.UrlBox.getValue().trim();
            if (url.length > 0)
            {
                let type: VideoType;
                let id = $$.youtubeId(url);
                videos.push({ Url: vidControl.UrlBox.getValue(), Description: vidControl.DescriptionBox.getValue(), Type: type, Id: id });
            }
        }
        return videos;
    }

    private _onAddVideoClick(): void
    {
        this._addVideo({} as Video);
    }

    private _onPnlClick(evt): void
    {
        let target = $$.getParent(evt.target, "a", "deleteImage")
        if (target)
        {
            let container = $$.getParent(target, "div", "videoContainer");
            let index = $(container).index();
            container.remove();
            this._videoControls.splice(index, 1);
        }
        target = $$.getParent(evt.target, "img");
        if (target)
        {

            let videoId = target.dataset.videoid;

            if (videoId)
            {
                $$videoPlayer.open(videoId);
            }
        }
    }

    private _onTxtUrlChange(sender: TextBox)
    {
        let index = $$.indexOfElement(this._videoControls, sender, "UrlBox");
        if (index !== null)
        {
            let controls = this._videoControls[index];
   
            let id = $$.youtubeId(sender.getValue().trim());
            if (id)
            {
                $$.getYoutubeInfo(id, (jqXHR: JQueryXHR, status: string) =>
                {
                    let data = jqXHR.responseJSON;
                    let info = data.items[0];
                    if (info.status.embeddable)
                    {
                        if (!controls.DescriptionBox.getValue())
                        {
                            controls.DescriptionBox.setValue(info?.snippet?.title || "");
                        }
                      
                        controls.ImagePreview.src = "https://img.youtube.com/vi/" + id + "/1.jpg";
                        controls.ImagePreview.dataset.videoid = id;
                        $$.show(controls.ImagePreview);
                    }
                    else
                    {
                        alert("The selected video cannot be embedded.  Please find another.");
                        controls.UrlBox.setValue(null);
                    }
                })

                
            }
            else
            {
                $$.hide(controls.ImagePreview);
            }
        }
    }

    private registerControl(urlBox, descriptionBox, imgPreview, index: number)
    {
        if (!this._videoControls[index])
        {
            this._videoControls[index] = {};
        }
        if (urlBox)
        {
            this._videoControls[index].UrlBox = urlBox;
        }
        if (descriptionBox)
        {
            this._videoControls[index].DescriptionBox = descriptionBox;
        }
        if (imgPreview)
        {
            this._videoControls[index].ImagePreview = imgPreview;
        }
    }

    private _addVideo(video: Video): void
    {
        this._videoControls.push({});
        let videoId = $$.youtubeId(video?.Url);
        let currentIndex = this._videoControls.length - 1;
        let content = (
            <div className="videoContainer">
                <span style={{ flex: "1", marginTop: "-10px" }}>
                    <TextBox Descriptor="Url"
                        Value={video.Url || ""}
                        style={{ width: "100%", marginTop: "10px" }}
                        ref={(ref) => this.registerControl(ref, null, null, currentIndex)}
                        onChange={this._onTxtUrlChange.bind(this)} /><br />
                    <TextBox Descriptor="Description" style={{ width: "100%", marginTop: "10px" }} Value={video.Description || ""}
                        ref={(ref) =>  this.registerControl(null, ref, null, currentIndex)} />
                </span>

                <div className="videoThumb" style={{ display: "inline-block", marginLeft: "10px", verticalAlign: "top", flex: "1 0% 0%" }} >
                    <img style={{ display: "none" }} ref={(ref) => this.registerControl(null, null, ref, currentIndex)} data-videoId={videoId} />
                </div>

                <a href="javascript:void(0);" className="deleteImage" style={{ marginLeft: "8px" }}></a>
            </div>);
        $$.appendChild(this._pnlVideos, content);
        
        //(React as any).appendChild(this._pnlVideos, content);

        if (videoId)
        {
            this._videoControls[currentIndex].ImagePreview.src = "https://img.youtube.com/vi/" + videoId + "/1.jpg";
            $$.show(this._videoControls[currentIndex].ImagePreview);
        }
    }

    public render()
    {
        return (<div className="videoSelector" ref={(ref) => this._registerContainer(ref)} >
            <label className="labelHeader">Videos</label>
            <div style={{ marginTop: "5px"}} ref={(ref) => this._pnlVideos = ref} onClick={this._onPnlClick.bind(this)}></div>
            <a href="javascript:void(0);" style={{ fontSize: "10pt", display:"inline-block" }} onClick={(this._onAddVideoClick as any).bind(this)}>Add Video</a>
        </div >);
    }
}